import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// Import ./BusBookingForm.css'Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import "./BusBookingForm.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, Spinner } from "react-bootstrap";
// import FlightDeal from "../../../components/MainHome/Home/innerComponents/FlightDeal";
import moment from "moment";
import { DayPickerRangeController } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import axios from "axios";
import { Autoplay, Pagination } from "swiper/modules";
import { AiOutlineSwap } from "react-icons/ai";
import WebOffer from "../Home/Home/WebOffer";
import WhyBookUsNew from "../Home/Home/WhyBookUsNew";
import MobileApp from "../Flight/FlightSearchMobile/MobileApp";
import BusTopSearch from "./BusTopSearch";
import AboutBus from "./AboutBus";
import RecentSearch from "./RecentSearch";
import { IoIosArrowDropdownCircle } from "react-icons/io";

export const data = [
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_204,dpr_2/offermgmt/images/banner/RR_Hifive_0712.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/BBD/CTINT_RR_FLIGHTS_29052023.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/BBD/GiftCards_RR_12072023.png",
  },
  {
    img: "https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_260,h_205,dpr_2/offermgmt/images/banner/RR_LMD_H_3001.jpg",
  },
];

const bookusdata = [
  {
    img: "/Images/Icons/esy-flights.svg",
    head: "Easy Booking",
    desc: " Book Flights Easily and Grab Exciting Offers!",
  },
  {
    img: "/Images/Icons/down-arrows.svg",
    head: "Lowest Price",
    desc: "Guaranteed Low Rates on Hotels, Holiday Packages, and Flights",
  },
  {
    img: "/Images/Icons/return-boxs.svg",
    head: "Instant Refund",
    desc: "Get Quick and Easy Refunds on All Your Travel Bookings!",
  },
  {
    img: "/Images/Icons/24-hoursa.svg",
    head: "24/7 Support",
    desc: "24/7 Support for All Your Travel Queries — We're Here to Help!",
  },
  {
    img: "/Images/Icons/hot-sales.svg",
    head: "Exciting Deals",
    desc: "Unlock Exciting Deals on Flights, Hotels, Buses, Car Rentals, and Tours!",
  },
];

export var settings = {
  dots: false,
  autoplay: true,
  autoplaySpeed: 1500,
  infinite: true,
  speed: 100,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export const extractBracketValue = (str) => {
  const regex = /\(([^)]+)\)/;
  const match = regex.exec(str);
  return match ? match[1] : null;
};
const BUS_CACHE_NAME = "bus-search-cache";
const BUS_CACHE_DURATION = 30 * 24 * 60 * 60 * 1000; // 1 month

export const insertBusSearchIntoCache = async (busData) => {
  const cache = await caches.open(BUS_CACHE_NAME);

  const timestampedData = { ...busData, timestamp: Date.now() };

  const response = new Response(JSON.stringify(timestampedData), {
    headers: { "Content-Type": "application/json" },
  });

  // Key pattern: source-destination-date-timestamp
  const cacheKey = `${busData.source}-${busData.destination}-${busData.journeyDate}-${timestampedData.timestamp}`;

  await cache.put(new Request(cacheKey), response);

  // Enforce max 8 searches
  const keys = await cache.keys();
  if (keys.length > 8) {
    const keyDataPairs = await Promise.all(
      keys.map(async (key) => {
        const res = await cache.match(key);
        const data = await res.json();
        return { key, timestamp: data.timestamp };
      })
    );

    keyDataPairs.sort((a, b) => a.timestamp - b.timestamp);

    const deleteKeys = keyDataPairs.slice(0, keys.length - 8);
    for (let { key } of deleteKeys) {
      await cache.delete(key);
    }
  }
};

export const fetchValidBusSearchesFromCache = async () => {
  const cache = await caches.open(BUS_CACHE_NAME);
  const keys = await cache.keys();

  const validSearches = [];

  for (let key of keys) {
    const res = await cache.match(key);
    const data = await res.json();

    if (Date.now() - data.timestamp < BUS_CACHE_DURATION) {
      validSearches.push(data);
    } else {
      await cache.delete(key);
    }
  }

  return validSearches.sort((a, b) => b.timestamp - a.timestamp).slice(0, 8);
};

const BusBookingForm = () => {
  const [active2] = useState(false);

  const [staticBusCities, setStaticBusCities] = useState([]);
  const [isLoadingFrom, setIsLoadingFrom] = useState(false);
  const [isLoadingTo, setIsLoadingTo] = useState(false);
  const [topCitiesFrom, setTopCitiesFrom] = useState([]);
  const [topCitiesTo, setTopCitiesTo] = useState([]);

  useEffect(() => {
    const loadStaticCities = async () => {
      try {
        const response = await fetch(
          `${process.env.PUBLIC_URL || ""}/citiesData.js`,
          { cache: "no-store" }
        );
        const scriptText = await response.text();

        const transformed = scriptText
          .replace(/^[\s\S]*?export\s+const\s+busCities\s*=\s*/m, "return ")
          .replace(/;\s*$/, ";");
        const parser = new Function(transformed);
        const cities = parser();
        if (Array.isArray(cities)) {
          setStaticBusCities(cities);

          const popular = [
            "Delhi",
            "Mumbai",
            "Bengaluru",
            "Bangalore",
            "Hyderabad",
            "Chennai",
            "Kolkata",
            "Pune",
            "Ahmedabad",
            "Jaipur",
            "Surat",
            "Lucknow",
          ];
          const picked = [];
          for (let name of popular) {
            const found = cities.find((c) =>
              String(c.CityName || "")
                .toLowerCase()
                .startsWith(name.toLowerCase())
            );
            if (found && !picked.some((p) => p.CityId === found.CityId)) {
              picked.push(found);
            }
            if (picked.length >= 10) break;
          }
          setTopCitiesFrom(picked);
          setTopCitiesTo(picked);
        }
      } catch (e) {
      } finally {
      }
    };
    loadStaticCities();
  }, []);

  const filterAndRankCities = (cities, value) => {
    const v = (value || "").toLowerCase();
    if (!v) return [];
    return cities
      .filter((user) => {
        return (
          user &&
          ((user.CityName && String(user.CityName).toLowerCase().includes(v)) ||
            (user.CityId &&
              String(user.CityId).toString().toLowerCase().includes(v)))
        );
      })
      .map((user) => {
        let priority = 2;
        if (user.CityName && String(user.CityName).toLowerCase().includes(v)) {
          priority = 1;
        } else if (
          user.CityId &&
          String(user.CityId).toString().toLowerCase().includes(v)
        ) {
          priority = 2;
        }
        return { ...user, priority };
      })
      .sort((a, b) => a.priority - b.priority);
  };

  useEffect(() => {
    const handleResize = () => {
      setBreakpoints();
    };
    window.addEventListener("resize", handleResize);
    setBreakpoints();
    return () => window.removeEventListener("resize", handleResize);
  });

  const setBreakpoints = () => {
    const isSmallScreen = window.innerWidth <= 768;
    const isMediumScreen = window.innerWidth > 768 && window.innerWidth <= 992;

    if (isSmallScreen) {
      setDateRangeConfig(1, 30, 30);
    } else if (isMediumScreen) {
      setDateRangeConfig(1, 40, 60);
    } else {
      setDateRangeConfig(2, 40, 50);
    }
  };

  const setDateRangeConfig = (numberOfMonths, daysize) => {
    setNumberOfMonths(1);
  };

  const [numberOfMonths, setNumberOfMonths] = useState(1);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [calVisible, setCalVisible] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calVisible && !event.target.closest(".busSearchForm-Date")) {
        setCalVisible(false);
        setFocusedInput(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calVisible]);

  const isSameDay = (date1, date2) => date1.isSame(date2, "day");

  const todaySearch = () => {
    const today = moment();
    setStartDate(today);
    setEndDate(null);
    setDate(today.format("YYYY-MM-DD"));
    setFocusedInput(null);
    setCalVisible(false);
  };

  const tommorowSearch = () => {
    const tomorrow = moment().add(1, "day");
    setStartDate(tomorrow);
    setEndDate(null);
    setDate(tomorrow.format("YYYY-MM-DD"));
    setFocusedInput(null);
    setCalVisible(false);
  };

  const renderDayContents = (day) => {
    const isStartDate = startDate && isSameDay(day, startDate);
    const isEndDate = endDate && isSameDay(day, endDate);
    const isInRange =
      startDate && endDate && day.isBetween(startDate, endDate, "day", "[]");

    let classNames = ["DayPicker-Day"];
    if (isStartDate) classNames.push("DayPicker-Day--start");
    if (isEndDate) classNames.push("DayPicker-Day--end");
    if (isInRange) classNames.push("DayPicker-Day--range");

    return (
      <div className={classNames.join(" ")}>
        <span style={{ fontWeight: "600", fontSize: "13px" }}>
          {day.format("D")}
        </span>
        <br />
      </div>
    );
  };

  const toggleCalendar = (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Toggle calendar called, current calVisible:", calVisible);
    const newCalVisible = !calVisible;
    setCalVisible(newCalVisible);
    if (newCalVisible) {
      setFocusedInput("startDate");
      console.log("Calendar opened, focusedInput set to startDate");
    } else {
      setFocusedInput(null);
      console.log("Calendar closed");
    }
  };

  const handleChange = () => {};
  const [clickDestination, SetClickDestination] = useState(false);
  const [clickDestination2, SetClickDestination2] = useState(false);

  const [searchInput, setSearchInput] = useState("Delhi (DEL)");
  const [searchInput2, setSearchInput2] = useState("Jaipur (JAI)");
  const [cities2, setCities2] = useState([]);
  const [cities22, setCities22] = useState([]);
  const [isItemSelected, setIsItemSelected] = useState(false);
  const [isItemSelected2, setIsItemSelected2] = useState(false);
  const [searchedAirport, setSearchedAirport] = useState("Source City");
  const [searchedAirport2, setSearchedAirport2] = useState("Destination City");

  const fetchDatas = async (value) => {
    setIsLoadingFrom(true);
    const payload = {
      city: value,
    };
    const response = await axios.post(
      "https://admin.travelsdata.com/api/Bus/City",
      payload
    );
    const json = response.data;

    const results = json.data
      .filter((user) => {
        return (
          user &&
          ((user.CityName &&
            user.CityName.toLowerCase().includes(value.toLowerCase())) ||
            (user.CityId &&
              user.CityId.toString()
                .toLowerCase()
                .includes(value.toLowerCase())))
        );
      })
      .map((user) => {
        let priority = 3;

        if (
          user.AIRPORTCODE &&
          user.AIRPORTCODE.toLowerCase().includes(value.toLowerCase())
        ) {
          priority = 1;
        } else if (
          user.CityName &&
          user.CityName.toLowerCase().includes(value.toLowerCase())
        ) {
          priority = 2;
        } else if (
          user.COUNTRYNAME &&
          user.COUNTRYNAME.toLowerCase().includes(value.toLowerCase())
        ) {
          priority = 3;
        }

        return { ...user, priority };
      })
      .sort((a, b) => a.priority - b.priority);
    console.log("RESULTS", results);
    setCities2(results);
    setIsLoadingFrom(false);
  };

  const handleInputChange = (value) => {
    const typed = value || "";
    const lower = typed.trim().toLowerCase();
    setSearchInput(typed);
    SetClickDestination(true);
    setIsItemSelected(false);

    if (lower.length < 3) {
      setCities2(topCitiesFrom);
      setIsLoadingFrom(false);
      return;
    }

    const staticMatches = filterAndRankCities(staticBusCities, lower);
    if (staticMatches.length > 0) {
      setCities2(staticMatches);
      setIsLoadingFrom(false);
      return;
    }

    fetchDatas(lower);
  };

  const fetchDatass = async (value) => {
    setIsLoadingTo(true);

    const payload = {
      city: value,
    };

    const response = await axios.post(
      "https://admin.travelsdata.com/api/Bus/City",
      payload
    );
    const json = response.data;

    const results = json.data
      .filter((user) => {
        return (
          user &&
          ((user.CityName &&
            user.CityName.toLowerCase().includes(value.toLowerCase())) ||
            (user.CityId &&
              user.CityId.toLowerCase().includes(value.toLowerCase())))
        );
      })
      .map((user) => {
        let priority = 2;

        if (
          user.CityName &&
          user.CityName.toLowerCase().includes(value.toLowerCase())
        ) {
          priority = 1;
        } else if (
          user.CityId &&
          user.CityId.toLowerCase().includes(value.toLowerCase())
        ) {
          priority = 2;
        }

        return { ...user, priority };
      })
      .sort((a, b) => a.priority - b.priority);

    setCities22(results);
    setIsLoadingTo(false);
  };

  const handleInputChange2 = (value) => {
    const typed = value || "";
    const lower = typed.trim().toLowerCase();
    setSearchInput2(typed);
    SetClickDestination2(true);
    setIsItemSelected2(false);

    if (lower.length < 3) {
      setCities22(topCitiesTo);
      setIsLoadingTo(false);
      return;
    }

    const staticMatches = filterAndRankCities(staticBusCities, lower);
    if (staticMatches.length > 0) {
      setCities22(staticMatches);
      setIsLoadingTo(false);
      return;
    }

    fetchDatass(lower);
  };

  // const handleInputChange2 = (value) => {
  //   setSearchInput2(value.toLowerCase());
  //   fetchDatass(value.toLowerCase());
  //   SetClickDestination2(true);
  //   setIsItemSelected2(false);
  // };

  useEffect(() => {
    localStorage.setItem(
      "walletData",
      JSON.stringify({
        Id: 91,
        Username: "AGN091",
        "Company Name": "Trip Navigate",
        "First Name": "Guruansh Singh",
        Email: "guruansh@holidaychacha.com",
        Phone: "9739504090",
        Wallet: "7200000",
        "Credit Limit": "0",
      })
    );
  }, []);

  const [source, setSource] = useState({ CityId: "230", CityName: "Delhi" });
  const [destination, setDestination] = useState({
    CityId: "5222",
    CityName: "Jaipur",
  });
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

  const navigate = useNavigate();

  // const handleSourceSelect = (selectedCity) => {
  //   setSource(selectedCity); // selectedCity = { CityId: "123", CityName: "Delhi" }
  // };

  const handleSourceSelect = (selectedCity) => {
    const cityName = String(selectedCity.CityName || "");
    const countryName = selectedCity.CountryName
      ? `, ${selectedCity.CountryName}`
      : "";
    setSource({ CityId: selectedCity.CityId, CityName: cityName });
    setSearchInput(cityName);
    setSearchedAirport(`${cityName}${countryName}`);
    setIsItemSelected(true);
    SetClickDestination(false);
  };

  const handleDestinationSelect = (selectedCity) => {
    const cityName = String(selectedCity.CityName || "");
    const countryName = selectedCity.CountryName
      ? `, ${selectedCity.CountryName}`
      : "";
    setDestination({ CityId: selectedCity.CityId, CityName: cityName });
    setSearchInput2(cityName);
    setSearchedAirport2(`${cityName}${countryName}`);
    setIsItemSelected2(true);
    SetClickDestination2(false);
  };

  const [cacheData, setCacheData] = useState([]);

  useEffect(() => {
    const loadCache = async () => {
      const cached = await fetchValidBusSearchesFromCache();
      setCacheData(cached);
    };
    loadCache();
  }, []);

  console.log("Bus recent search cache:", cacheData);

  // handleSearch (fire-and-forget caching)
  const handleSearch = () => {
    if (!source.CityId || !destination.CityId || !date) {
      alert("Please select source, destination and journey date");
      return;
    }

    const busData = {
      source: source.CityName,
      destination: destination.CityName,
      sourceId: source.CityId,
      destinationId: destination.CityId,
      journeyDate: date,
    };

    // Fire-and-forget: insert into cache but don't block navigation
    insertBusSearchIntoCache(busData).catch((err) => {
      console.error("Failed inserting bus cache:", err);
    });

    // Build query and navigate immediately
    const query = `?from=${encodeURIComponent(
      source.CityName
    )}&to=${encodeURIComponent(destination.CityName)}&cityId=${
      source.CityId
    }&desId=${destination.CityId}&journeyDate=${date}`;
    navigate(`/buslisting${query}`);
  };

  console.log("cache data", cacheData);

  // const handleSearch = () => {

  //   const query = `?from=${encodeURIComponent(
  //     source.CityName
  //   )}&to=${encodeURIComponent(destination.CityName)}&cityId=${
  //     source.CityId
  //   }&desId=${destination.CityId}&journeyDate=${date}`;
  //   navigate(`/buslisting${query}`);
  // };

  return (
    <div className="bookimg_form_containerrr bus_booking_form_containerr">
      <div style={{ position: "relative" }}>
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 50000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="mySwiper"
          style={{ height: "300px" }}
        >
          <SwiperSlide>
            <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://www.keralatourism.org/images/caravan-tourism/book-trip/large/gokulam-caravan/02.webp")',
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#1d489f36", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Search Buses</div>
                <div>Smooth Bus Booking, Unbeatable Low Prices</div>
              </h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://www.keralatourism.org/images/caravan-tourism/book-trip/large/gokulam-caravan/02.webp")',
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#190a0a", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Unlock Exclusive Flight Offers</div>
                <div>Bus Discounts, and Business Travel Solutions Today</div>
              </h1>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="backgroundBanner banner banner-image"
              style={{
                backgroundImage:
                  'url("https://www.keralatourism.org/images/caravan-tourism/book-trip/large/gokulam-caravan/02.webp")',
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
              data-v-0b3b4b19=""
              data-v-b9cf504c=""
            >
              <div
                className="overlay"
                style={{ backgroundColor: "#190a0a", opacity: "0.5" }}
              ></div>

              <img
                src="/Images/dream-feather-bg.png"
                alt="img-mark"
                className="img-mark"
                data-v-0b3b4b19=""
              />
              <h1 className="description" data-v-0b3b4b19="">
                <div>Experience Hassle-Free Bookings</div>
                <div>Luxury Travel, and Unmatched Service Only on Innovate Blues</div>
              </h1>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <Container>
        <div className="flightWidgetSection appendBottom40">
          <div className="searchWidgetContainer">
            <form
              data-cy="flightSW"
              className="fltWidgetSection appendBottom40 primaryTraveler busSearchForm"
            >
              <div className="makeFlex hrtlCenter">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "455px",
                  }}
                ></div>
              </div>
              <div className="fsw ">
                <div className="fsw_inner returnPersuasion">
                  <div
                    className="flt_fsw_inputBox searchCity inactiveWidget "
                    style={{ width: "310px" }}
                  >
                    <label htmlFor="fromCity">
                      <span className="lbl_input appendBottom10">From</span>
                      <input
                        data-cy="fromCity"
                        id="fromCity"
                        type="text"
                        className="fsw_inputField lineHeight36 latoBlack font30"
                        value={searchInput}
                        autoComplete="off"
                        onFocus={() => {
                          setSearchInput("");
                          setSearchedAirport("");
                          setIsItemSelected(false);
                          SetClickDestination(true);
                          // Show top cities immediately
                          setCities2(topCitiesFrom);
                        }}
                        onBlur={() => {
                          if (isItemSelected) SetClickDestination(false);
                        }}
                        onChange={(e) => handleInputChange(e.target.value)}
                      />

                      <p
                        className="code makeRelative"
                        title="DEL, Delhi Airport India"
                      >
                        <span
                          data-cy="defaultFromValue"
                          title=""
                          className="truncate airPortName "
                        >
                          {searchedAirport}
                        </span>
                      </p>
                    </label>
                    <div style={{ position: "relative" }}>
                      <div
                        className="cityselect"
                        style={{
                          position: "absolute",
                          color: "black",
                          backgroundColor: "white",

                          border: "1px solid #cdcdcd",
                          display: clickDestination ? "block" : "none",
                          width: "100%",
                          zIndex: 9,
                          top: "-42px",
                          maxHeight: 300,
                          overflow: "auto",
                          scrollbarWidth: "thin",
                        }}
                      >
                        {cities2.length !== 0 ? (
                          <>
                            {cities2.map((city, index) => (
                              // <div
                              //   role="option"
                              //   id={`react-autowhatever-1-section-0-item-${index}`}
                              //   aria-selected="false"
                              //   className={`react-autosuggest__suggestion ${
                              //     index === 0
                              //       ? "react-autosuggest__suggestion--first"
                              //       : ""
                              //   }`}
                              //   key={index}
                              //   onClick={() => handleSourceSelect(city)}
                              //   onMouseDown={() => handleSourceSelect(city)}
                              // >
                              //   <div className="makeFlex">
                              //     <img
                              //       className="icLocAlt appendRight8-bookings_form"
                              //       src="https://imgak.mmtcdn.com/flights/assets/media/dt/common/icons/ic-flight-onward.png"
                              //       alt="icon"
                              //     />
                              //     <div className="makeFlex flexOne column">
                              //       <div className="makeFlex flexOne spaceBetween">
                              //         <div className="makeFlex flexOne spaceBetween appendRight10">
                              //           <div className="makeFlex column flexOne appendRight10">
                              //             <p className="font_search_bookingss appendBottom5 blackText">
                              //               {city.CityName}
                              //             </p>
                              //             <p className="lightGreyText font12">
                              //               {city.CountryName
                              //                 ? city.CountryName
                              //                 : ""}
                              //             </p>
                              //           </div>
                              //         </div>
                              //         <div className="font14 lightGreyText latoBold">
                              //           {city.CityId}
                              //         </div>
                              //       </div>
                              //     </div>
                              //   </div>
                              // </div>
                              <div
                                className="auto-sugg-pre"
                                key={index}
                                onClick={() => handleSourceSelect(city)}
                                onMouseDown={() => handleSourceSelect(city)}
                              >
                                <ul>
                                  <li className="auto_sugg_list ">
                                    <div className="w_10 ">
                                      <div className="auto_sugg_img">
                                        <img
                                          src="https://www.easemytrip.com/images/auto-sugg-icon/place.png"
                                          alt="Location"
                                        />
                                      </div>
                                      {/* <div className="auto_sugg_add ">area</div> */}
                                    </div>
                                    <div className="w_85">
                                      <div className="auto_sugg_tttl ">
                                        {city.CityName}
                                      </div>
                                      {/* <span style={{ display: "none" }}>
                                      93705
                                    </span> */}
                                      <div className="auto_sugg_add " />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div
                            style={{
                              padding: "10px 5px",
                              fontSize: "12px",
                              textAlign: "center",
                              margin: "auto",
                              width: "100%",
                            }}
                          >
                            {isLoadingFrom ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />{" "}
                                Please wait we are fetching city list...
                              </>
                            ) : (
                              <>No matching cities found</>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <span className="fltSwipCircle">
                      <AiOutlineSwap color="#1a4f87" size={20} />
                      {/* <span className="flightsSprite fltSwipIcon" /> */}
                    </span>
                  </div>

                  <div
                    className="flt_fsw_inputBox searchToCity inactiveWidget busSearchForm-ToCity"
                    style={{ width: "310px" }}
                  >
                    <label htmlFor="toCity">
                      <span className="lbl_input appendBottom10">To</span>
                      <input
                        data-cy="toCity"
                        id="toCity"
                        type="text"
                        className="fsw_inputField lineHeight36 latoBlack font30"
                        value={searchInput2}
                        autoComplete="off"
                        onFocus={() => {
                          setSearchInput2("");
                          setSearchedAirport2("");
                          setIsItemSelected2(false);
                          SetClickDestination2(true);
                          // Show top cities immediately
                          setCities22(topCitiesTo);
                        }}
                        onBlur={() => {
                          if (isItemSelected2) SetClickDestination2(false);
                        }}
                        onChange={(e) => handleInputChange2(e.target.value)}
                      />

                      <p
                        className="code makeRelative"
                        title="BOM, Chhatrapati Shivaji International Airport India"
                      >
                        <span
                          data-cy="defaultToValue"
                          title=""
                          className="truncate airPortName "
                        >
                          {searchedAirport2}
                        </span>
                      </p>
                    </label>
                    <div style={{ position: "relative" }}>
                      <div
                        className="cityselect"
                        style={{
                          position: "absolute",
                          color: "black",
                          backgroundColor: "white",

                          border: "1px solid #cdcdcd",
                          display: clickDestination2 ? "block" : "none",
                          width: "100%",
                          zIndex: 9,
                          top: "-42px",
                          maxHeight: 300,
                          overflow: "auto",
                          scrollbarWidth: "thin",
                        }}
                      >
                        {cities22.length !== 0 ? (
                          <>
                            {cities22.map((city, index) => (
                              // <div
                              //   role="option"
                              //   id={`react-autowhatever-1-section-1-item-${index}`}
                              //   aria-selected="false"
                              //   className={`react-autosuggest__suggestion ${
                              //     index === 0
                              //       ? "react-autosuggest__suggestion--first"
                              //       : ""
                              //   }`}
                              //   key={index}
                              //   onClick={() => handleDestinationSelect(city)}
                              //   onMouseDown={() =>
                              //     handleDestinationSelect(city)
                              //   }
                              // >
                              //   <div className="makeFlex">
                              //     <img
                              //       className="icLocAlt appendRight8-bookings_form"
                              //       src="https://imgak.mmtcdn.com/flights/assets/media/dt/common/icons/ic-flight-onward.png"
                              //       alt="icon"
                              //     />
                              //     <div className="makeFlex flexOne column">
                              //       <div className="makeFlex flexOne spaceBetween">
                              //         <div className="makeFlex flexOne spaceBetween appendRight10">
                              //           <div className="makeFlex column flexOne appendRight10">
                              //             <p className="font_search_bookingss appendBottom5 blackText">
                              //               {city.CityName}
                              //             </p>
                              //             <p className="lightGreyText font12">
                              //               {city.CountryName}
                              //             </p>
                              //           </div>
                              //         </div>
                              //         <div className="font14 lightGreyText latoBold">
                              //           {city.CityId}
                              //         </div>
                              //       </div>
                              //     </div>
                              //   </div>
                              // </div>
                              <div
                                className="auto-sugg-pre"
                                key={index}
                                onClick={() => handleDestinationSelect(city)}
                                onMouseDown={() =>
                                  handleDestinationSelect(city)
                                }
                              >
                                <ul>
                                  <li className="auto_sugg_list ">
                                    <div className="w_10 ">
                                      <div className="auto_sugg_img">
                                        <img
                                          src="https://www.easemytrip.com/images/auto-sugg-icon/place.png"
                                          alt="Location"
                                        />
                                      </div>
                                      {/* <div className="auto_sugg_add ">area</div> */}
                                    </div>
                                    <div className="w_85">
                                      <div className="auto_sugg_tttl ">
                                        {city.CityName}
                                      </div>
                                      {/* <span style={{ display: "none" }}>
                                      93705
                                    </span> */}
                                      <div className="auto_sugg_add " />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div
                            style={{
                              padding: "10px 5px",
                              fontSize: "12px",
                              textAlign: "center",
                              margin: "auto",
                              width: "100%",
                            }}
                          >
                            {isLoadingTo ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />{" "}
                                Please wait we are fetching city list...
                              </>
                            ) : (
                              <>No matching cities found</>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="flt_fsw_inputBox dates inactiveWidget busSearchForm-Date"
                    onClick={toggleCalendar}
                    style={{ cursor: "pointer" }}
                  >
                    <label
                      htmlFor="departure depart_bus_date"
                      onClick={toggleCalendar}
                    >
                      <span className="lbl_input appendBottom10">Date</span>
                      <input
                        data-cy="departure"
                        id="departure"
                        type="text"
                        className="fsw_inputField font20"
                        defaultValue="Monday, 3 Jun 2024"
                        onChange={handleChange}
                        value={startDate ? startDate.format("MM/DD/YYYY") : ""}
                        readOnly
                        onClick={toggleCalendar}
                        style={{ cursor: "pointer" }}
                      />
                      <p
                        data-cy="departureDate"
                        className="blackText font20 code lineHeight36"
                      >
                        <span className="font30 latoBlack">
                          {startDate ? startDate.format("D") : "--"}{" "}
                        </span>
                        <span>
                          {startDate ? startDate.format("MMM") : "Month"}
                        </span>
                        <span className="shortYear">
                          {startDate ? startDate.format("YY") : ""}
                        </span>
                      </p>
                      <p data-cy="departureDay" className="code ">
                        {startDate ? startDate.format("dddd") : "Select a date"}
                      </p>
                    </label>
                    <div className="date-controls bus_date_controlll">
                      <div className="date-controls-sec" onClick={todaySearch}>
                        Today
                      </div>
                      <div
                        className="date-controls-sec"
                        onClick={tommorowSearch}
                      >
                        Tomorrow
                      </div>
                      {/*div class="date-controls-sec" onclick="dayafterSearch();">Day After</div*/}
                    </div>

                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        zIndex: "2000",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        display: calVisible ? "block" : "none",
                      }}
                    >
                      {console.log(
                        "Calendar container render - calVisible:",
                        calVisible,
                        "display:",
                        calVisible ? "block" : "none"
                      )}
                      {calVisible && (
                        <DayPickerRangeController
                          startDate={startDate}
                          endDate={null}
                          onDatesChange={({ startDate }) => {
                            if (startDate) {
                              setStartDate(startDate);
                              setDate(startDate.format("YYYY-MM-DD"));
                              setCalVisible(false);
                              setFocusedInput(null);
                            }
                          }}
                          isOutsideRange={(day) =>
                            day.isBefore(moment(), "day")
                          }
                          focusedInput={focusedInput}
                          onFocusChange={(focused) => {
                            if (!focused) {
                              setCalVisible(false);
                            }
                          }}
                          renderDayContents={renderDayContents}
                          numberOfMonths={numberOfMonths}
                        />
                      )}
                    </div>
                  </div>

                  <div className="flt_fsw_inputBox dates reDates inactiveWidget search_flight_bookingsss ">
                    <button
                      onClick={handleSearch}
                      className="mat-stroked-button"
                    >
                      Search Bus
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {cacheData && cacheData.length !== 0 && (
          <div
            className={`makeFlex hrtlCenter flightFare`}
            style={{ marginTop: "20px", padding: "0px 5px" }}
          >
            <div
              className="ng-tns-c8-3 ng-star-inserted"
              style={{
                cursor: "pointer",
                marginLeft: "19px",
                marginTop: "-6px",
                marginRight: "15px",
              }}
            >
              <Link
                className="active"
                rel="noopener"
                style={{ color: "#1d489f" }}
                // onClick={handleClick}
              >
                <IoIosArrowDropdownCircle size={20} /> You’ve Searched
              </Link>
            </div>

            <div className="specialFareContainer relative makeFlex centerContainer">
              <div style={{ paddingLeft: "10px", color: "#333" }}>
                <RecentSearch cacheData={cacheData} />
              </div>
            </div>
          </div>
        )}
      </Container>
      <WebOffer />
      <BusTopSearch />
      <WhyBookUsNew bookusdata={bookusdata} />
      {/* <MobileApp
        backgroundImage="https://www.keralatourism.org/images/caravan-tourism/book-trip/large/gokulam-caravan/02.webp"
        title="Download Our Mobile App"
        description="Book your bus ticket with huge discounts. Refer friends and earn generous bonuses from their bookings"
      /> */}
      <AboutBus />
    </div>
  );
};

export default BusBookingForm;
